import env from 'libs/constants/env';

const safeParseJSON = (value: string | undefined): any[] => {
  try {
    return value ? JSON.parse(value) : [];
  } catch (error) {
    console.error(`Error parsing JSON: ${error}`);
    return [];
  }
};

export const channelNotNiubiz = safeParseJSON(env.FLOW_WITHOUT_NIUBIZ).reduce(
  (acum: Record<string, boolean>, current: string) => {
    acum[current] = true;
    return acum;
  },
  {},
);

export const listChannelBCP = safeParseJSON(env.FLOW_CHANNEL_BCP).reduce(
  (acum: Record<string, boolean>, current: string) => {
    acum[current] = true;
    return acum;
  },
  {},
);
